define(["exports", "styled-components"], function (_exports, _styledComponents) {
  "use strict";

  var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _styledComponents = _interopRequireWildcard(_styledComponents);
  var sizeHelper = {
    extraSmall: '4px',
    small: '8px',
    regular: '16px',
    medium: '24px',
    large: '32px',
    extraLarge: '48px',
    ultraLarge: '64px'
  };

  var Spacing = _styledComponents.default.div.withConfig({
    displayName: "Spacing",
    componentId: "sc-7xsmjt-0"
  })(["flex:", ";", ";"], function (_ref) {
    var flex = _ref.flex;
    return flex ? flex : 'initial';
  }, function (_ref2) {
    var horizontal = _ref2.horizontal,
        size = _ref2.size;
    return horizontal ? sizeHelper[size] ? (0, _styledComponents.css)(["min-width:", ";"], sizeHelper[size]) : (0, _styledComponents.css)(["min-width:", ";"], sizeHelper.regular) : sizeHelper[size] ? (0, _styledComponents.css)(["height:", ";"], sizeHelper[size]) : (0, _styledComponents.css)(["height:", ";"], sizeHelper.regular);
  });

  var _default = Spacing;
  _exports.default = _default;
});